<template>
  <div>
    <span class="medical-name" v-if="session">{{ session.department.title }}</span>

    <el-dropdown
      v-if="currentProfile"
      class="profile-drop"
      @command="handleCommand">
        <span class="el-dropdown-link">
           <el-avatar
             :style="{background: avatarColor(currentProfile.id)}">{{ avatarChar(currentProfile.name) }}</el-avatar>
        </span>
      <el-dropdown-menu slot="dropdown" trigger="hover">
        <div class="profile-card">
          <div class="profile-card__name">{{ currentProfile.name }}</div>
          <div class="profile-card__email">{{ currentProfile.email }}</div>
        </div>
        <el-dropdown-item command="logout" divided>Выйти</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'ProfileAvatarButton',
  methods: {
    ...mapActions({
      showProfile: 'dialogs/profile/show'
    }),
    ...mapMutations({
      setOtherItemMenu: 'menu/OTHER'
    }),
    handleCommand (command) {
      if (command === 'logout') {
        this.$store.dispatch('auth/LOGOUT').then(() => {
          this.$notify.success({
            title: 'Удачно...',
            message: 'До свидания!'
          })
        }).catch(() => {
          this.$notify.error({
            title: 'Упс...',
            message: 'Ошибка всязи'
          })
        }).finally(() => {
          this.$router.push({ name: 'auth.signin' })
        })
      }

      if (command === 'clear_cache') {
        this.$api.system.clearCache().then(() => {
          this.$message({
            message: 'cacheSuccess',
            type: 'success'
          })
        })
      }
    },
    avatarColor (id) {
      const colors = [
        '#ec8a41',
        '#999999',
        '#333333',
        '#ec6263',
        '#4bafec',
        '#9774ec'
      ]
      const color = id % colors.length
      return colors[color]
    },
    avatarChar (name) {
      return name.charAt(0).toUpperCase()
    }
  },
  computed: {
    ...mapState('auth', {
      currentProfile: state => state.profile
    }),
    ...mapState('session', {
      session: state => state.session
    }),
    visible: {
      get () {
        return this.status === 'visible'
      },
      set () {
        this.status = 'hidden'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.medical-name {
  color: #fff;
}

.profile-card {
  padding: 10px 20px;

  &__name {
    font-weight: 500;
    font-size: 15px;
  }

  &__email {
    margin-top: 10px;
    font-size: 12px;
  }
}

.profile-drop {
  color: #FFF;
  cursor: pointer;
  margin-left: 10px;

  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
